import { getDesktopFiltersMicrofrontendApi } from './getDesktopFiltersMicrofrontendApi';
import { getSearchStringMicrofrontendAPI } from './getSearchStringMicrofrontendApi';
import { IMicrofrontendsAPI } from 'shared/types/microfrontends/types';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getSearchStringMicrofrontendAPI,
    getDesktopFiltersMicrofrontendApi,
  };
}
